/**
 * Registry of available global modal components.
 * Uses string identifiers that map to dynamic component imports.
 */
export const GLOBAL_MODAL_COMPONENTS = {
  AppDownloadAppModalCritical: 'AppDownloadAppModalCritical',
  AppDownloadAppModalSubtle: 'AppDownloadAppModalSubtle',
  BookCallModal: 'ModalsBookCallModal',
  BookingPaymentDetailsModal: 'BookingPaymentDetailsModal',
  BookingPayoutDetailsModal: 'BookingPayoutDetailsModal',
  BookingReviewsReportModal: 'BookingReviewsReportModal',
  BookingUpsellModal: 'BookingUpsellModal',
  ChangeRequestErrorModal: 'BookingEditChangeRequestErrorModal',
} as const
Object.freeze(GLOBAL_MODAL_COMPONENTS)
export type GLOBAL_MODAL_COMPONENTS = typeof GLOBAL_MODAL_COMPONENTS[keyof typeof GLOBAL_MODAL_COMPONENTS]
